"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Growth;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function Growth() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "159",
    height: "158",
    viewBox: "0 0 159 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("ellipse", {
    cx: "80",
    cy: "79.1875",
    rx: "75",
    ry: "73.9062",
    stroke: "#059469",
    strokeWidth: "8"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M154.5 69.5002C143.5 12.0002 92.5 0.00024427 63.5 6.5001C59.5665 7.38174 26 15.0017 9.00003 55.5017C7.63531 58.7529 -6.99939 99.0016 28.5 133.002C39.0006 145.002 81.5006 163.501 112.001 146.001",
    stroke: "#802AB8",
    strokeWidth: "8",
    strokeMiterlimit: "16",
    strokeLinecap: "round",
    strokeDasharray: "0.5 0.5"
  }));
}